<template>

    <tq-loader-container :p_show-loader_b="server_currentUserData_c === undefined" :p_tq-loader_b="true" class="TQ_center">
        <div class="TQ_minHeight_500px TQ_padding_8px">


            <!-- current user data -->
            <fcuc-profile v-if="server_currentUserData_c && !server_currentUserData_c.ud_m_guestUser_b()"/>

            <!-- login -->
            <tq-login v-else
                      :p_system_lang-code_e="store_system_langCode_ve.val"
                      :p_fb-auth_c="store_fbAuth_vc.val"
                      :p_show-guest-option_b="false"
                      :p_upgrade-user_b="false"
                      class="TQ_margin_top_8px TQ_maxWidth_400px TQ_bg_white TQ_borderRadius TQ_center"/>

        </div>
    </tq-loader-container>
</template>

<script>

    import {store_getStateValue_vo, store_var} from "@/store";
    import {
        serverAuth_currentUserData_get_vl_fp,
        serverAuth_currentUserData_remove_vl_f,
    } from "@/scripts/Server/S_ServerAuth";
    import TqLoaderContainer from "@/components/basic/TqLoaderContainer";
    import FcucProfile from "@/components/unpure/FcucProfile";
    import TqLogin from "@/components/complex/TqLogin";
    import TqPopup from "@/components/basic/TqPopup";

    export default {
        name: "V_Player_Profile",
        components:{
            TqPopup,
            TqLoaderContainer,
            TqLogin,
            FcucProfile,
        },
        data(){
            return {

                returnDataAfterLogin_b: false,

                // store
                store_system_langCode_ve : store_getStateValue_vo(store_var.system_langCode),
                store_fbAuth_vc : store_getStateValue_vo(store_var.fb_auth),

                // server
                server_currentUserData_c : undefined,
            }
        },

        computed : {
            co_showMainLoader_b() {
                return this.server_currentUserData_c === undefined || (!this.returnDataAfterLogin_b && this.store_fbAuth_vc.val != null)
            }
        },

        // lifeCircle
        mounted(){

            // 1) get user data
            serverAuth_currentUserData_get_vl_fp(this.$options.name, (currentUserData_c) => {
                this.server_currentUserData_c = currentUserData_c

                if(this.store_fbAuth_vc.val){
                    this.returnDataAfterLogin_b = true
                }
            })

        },
        destroyed() {
            serverAuth_currentUserData_remove_vl_f(this.$options.name)
        },
    }
</script>

<style scoped lang="scss">

</style>
